import React, { useEffect } from "react";
import CustomTable from "../../../../components/Tables/CustomTable";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import {
  fetchUsersAsync,
  resetAdminState,
  setSelectedUser,
} from "../../../../redux/features/adminSlice";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ExportUsersCsvButton from "../components/ExportUsersCsvButton";
import { useUserFilters } from "../useUserFilters";
import UserFilterBar from "../UserFilterBar";
import {
  formatUserAmount,
  formatUserCount,
  getUserOrderCount,
  getUserProductCount,
} from "../userMetrics";

const VendorTable: React.FC = () => {
  const { vendors, isLoading } = useAppSelector((state) => state.admin);
  const filters = useUserFilters("VENDOR");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const columns = [
    { label: "S/N", field: "id" },
    { label: "Name of Vendor", field: "vendor_name" },
    { label: "Username", field: "username" },
    { label: "Phone Number", field: "phone_number" },
    { label: "Email", field: "email" },
    { label: "Brand Name", field: "brandName" },
    { label: "Business Phone Number", field: "business_phone_number" },
    { label: "Business Email", field: "business_email" },
    { label: "Business City", field: "business_city" },
    { label: "Country", field: "country" },
    { label: "Order Amount", field: "order_amount" },
    { label: "Order Count", field: "order_count" },
    { label: "Product Count", field: "product_count" },
    { label: "Reg. Date", field: "date_added" },
  ];

  const vendorData = vendors?.data?.data?.map((vendor: any, index: number) => {
    return {
      _vendor: vendor,
      id: index + 1,
      vendor_name: vendor?.fullName ?? "N/A",
      username: vendor?.username ?? "N/A",
      phone_number: vendor?.phoneNumber ?? "N/A",
      brand_name: vendor?.business?.name ?? "N/A",
      business_email: vendor?.business?.businessEmail ?? "N/A",
      business_phone_number: vendor?.business?.businessPhoneNumber ?? "N/A",
      business_city: vendor?.business?.businessCity ?? "N/A",
      country:
        (typeof vendor?.country === "string"
          ? vendor?.country
          : vendor?.country?.name) ?? "N/A",
      order_amount: formatUserAmount(vendor),
      order_count: formatUserCount(getUserOrderCount(vendor)),
      product_count: formatUserCount(getUserProductCount(vendor)),
      email: vendor?.email ?? "N/A",
      date_added: moment(vendor?.createdAt).format("MMM DD, YYYY"),
    };
  });

  useEffect(() => {
    dispatch(resetAdminState());
    dispatch(fetchUsersAsync(filters.listParams));
  }, [dispatch, filters.listParams]);

  const tabList = [
    { id: 1, name: "All Vendors", count: vendors?.data?.totalItems ?? 0 },
  ];

  return (
    <WhiteTitledCard>
      <div className="px-6">
        <UserFilterBar
          filters={filters}
          userType="VENDOR"
          panelId="vendor-filter-panel"
          searchPlaceholder="Search vendor name, email, username"
          actions={
            <ExportUsersCsvButton
              totalItems={vendors?.data?.totalItems ?? 0}
              params={filters.exportParams}
            />
          }
        />

        <div className="flex flex-col md:flex-row flex-wrap items-center gap-3 mb-4">
          {tabList?.map((tab) => (
            <div
              key={tab.id}
              className="space-x-2 cursor-pointer text-sm font-semibold p-2 text-black border-b-2 border-primary"
            >
              <span>{tab.name}</span>
              <span className="bg-lightPurple px-2 text-accent rounded-md">
                {tab?.count}
              </span>
            </div>
          ))}
        </div>

        <CustomTable
          data={{ columns, rows: vendorData }}
          onRowClick={(row) => {
            dispatch(setSelectedUser(row._vendor));
            navigate(`/user-management/vendor/${row._vendor?.id}`);
          }}
          noRecordText="No Vendor Users Available"
          loading={isLoading}
          showFooter={true}
          totalPages={vendors?.data?.totalPages}
          itemsPerPage={vendors?.data?.itemsPerPage}
          currentPage={filters.page}
          onPageChange={(value: number) => filters.setPage(value)}
          onLimitChange={(value: number) => {
            filters.setLimit(value);
            filters.setPage(0);
          }}
        />
      </div>
    </WhiteTitledCard>
  );
};

export default VendorTable;
